import { BaseModel } from "./base-model.model";

export class Category extends BaseModel {
    name!: string;
    description!: string;
}